<div class="bg--white">
  <scc-dsm3-nav-breadcrumbs [items$]="breadcrumbsItems$"></scc-dsm3-nav-breadcrumbs>
</div>

<section class="create-user">
  <div class="container">
    <div class="row no-padding">
      <div class="col-md-12">
        <h1 color="black">{{ isEdit ? 'EDITAR' : 'NOVO' }} UTILIZADOR</h1>
        <hr />
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
          <div class="form-group required">
            <label for="curUserName"><strong>Nome</strong></label>
            <input id="curUserName" type="text" formControlName="curUserName" />
          </div>

          <div class="form-group required">
            <label for="curUserUsername"><strong>Nome de utilizador</strong></label>
            <input id="curUserUsername" type="text" formControlName="curUserUsername" />
            <div
              class="alert alert-danger"
              *ngIf="curUserUsername.errors && curUserUsername.dirty && curUserUsername.errors.invalidUsername"
            >
              Nome de Utilizador inválido
            </div>
            <div
              class="alert alert-danger"
              *ngIf="!isEdit && curUserUsername.errors && curUserUsername.errors.existingUserAccount"
            >
              Nome de Utilizador já está a ser utilizado.
            </div>
            <div
              class="alert alert-danger"
              *ngIf="!isEdit && curUserUsername.errors && curUserUsername.errors.maxlength"
            >
              Nome de Utilizador não pode conter mais de 20 caracteres.
            </div>
          </div>

          <div class="form-group required">
            <label for="curUserEmail"><strong>Email</strong></label>
            <input id="curUserEmail" type="text" formControlName="curUserEmail" />
            <div
              class="alert alert-danger"
              *ngIf="!isEdit && curUserEmail.errors && curUserEmail.errors.emailAlreadyExists"
            >
              O email já está a ser utilizado.
            </div>
          </div>

          <div class="form-group" *ngIf="isProfileOrd && isEdit && curUserIsRetailer">
            <label for="curUserRetailerName"><strong>Comercializadora</strong></label>
            <input id="curUserRetailerName" type="text" value="{{ curUser.retailerName }}" disabled />
          </div>

          <div class="form-group">
            <label for="curUserPhone"><strong>Telefone</strong></label>
            <input id="curUserPhone" type="text" formControlName="curUserPhone" />
            <div
              class="alert alert-danger"
              *ngIf="curUserPhone.errors && curUserPhone.dirty && curUserPhone.errors.invalidPhoneNumber"
            >
              Telefone Inválido
            </div>
          </div>

          <div class="form-group">
            <label for="curUserPosition"><strong>Cargo/Tema</strong></label>
            <input id="curUserPosition" type="text" formControlName="curUserPosition" />
          </div>

          <div class="form-group" *ngIf="isProfileOrd && !isEdit">
            <ng-container *ngFor="let item of profiles">
              <label *ngIf="!isEdit || (!item.profileName.match('RET_') && !curUserIsRetailer)">
                <input type="radio" [value]="item.profileUniqueCode" formControlName="curUserProfile" />
                <span>{{ item.profileDescription }}</span>
              </label>
            </ng-container>
          </div>

          <div class="form-group required" *ngIf="!isEdit && isProfileOrd && curUserIsRetailer">
            <label for="curUserRetailerUniqueCode"><strong>Seleccione a Comercializadora</strong></label>
            <div class="select-wrapper">
              <select id="curUserRetailerUniqueCode" formControlName="curUserRetailerUniqueCode">
                <ng-container *ngFor="let item of retailersList">
                  <option *ngIf="item.retailerUniqueCode !== 'pt.edp.retailer.0'" value="{{ item.retailerUniqueCode }}">
                    {{ item.retailerName }}
                  </option>
                </ng-container>
              </select>
            </div>
          </div>

          <div class="form-group required check-list" *ngIf="!!formControls.curUserProfile.value">
            <label for="permissions-title"><strong>Permissões</strong></label>
            <input id="permissions-title" type="hidden" />
            <div class="row large-border" *ngFor="let operation of allPermissions | unique: 'operationTypeUniqueCode'">
              <div class="col-md-3 col-sm-12">{{ operation.operationTypeTitle }}</div>
              <div class="col-md-9 col-sm-12">
                <div
                  class="row border"
                  *ngFor="
                    let area of allPermissions
                      | filterBy: ['operationTypeUniqueCode'] : operation.operationTypeUniqueCode
                      | unique: 'areaUniqueCode'
                  "
                >
                  <div class="col-md-3 col-xs-12">{{ area.areaTitle }}</div>
                  <div
                    class="col-md-2 col-xs-6"
                    *ngFor="
                      let input of [
                        { key: '_read', label: 'Leitura' },
                        { key: '_write', label: 'Escrita' },
                      ]
                    "
                  >
                    <div *ngIf="(curUserIsRetailer && input.key === '_read') || input.key === '_write'">
                      <label>
                        <input
                          type="checkbox"
                          formControlName="perm_{{ area.areaUniqueCode + input.key }}"
                          (change)="switchPermission($event)"
                          [name]="'perm_' + area.areaUniqueCode + input.key"
                        />
                        <span>{{ input.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row large-border">
              <div class="col-md-3 col-sm-12">Menu</div>
              <div class="col-md-9 col-sm-12">
                <div class="row border" *ngFor="let permission of permissions; let i = index">
                  <div class="col-md-offset-3 col-md-9">
                    <div class="form-group">
                      <label>
                        <input
                          type="checkbox"
                          [formControlName]="permission.permKey"
                          (change)="switchPermission($event)"
                          [name]="permission.permKey"
                        />
                        <span>{{ permission.permName }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group required" *ngIf="assignableVisible">
            <label for="curUserAssignable1"><strong>Visível para atribuição</strong></label>
            <div>
              <label for="curUserAssignable1">
                <input id="curUserAssignable1" type="radio" formControlName="curUserAssignable" [value]="1" />
                <span> Sim</span>
              </label>
              <label for="curUserAssignable0">
                <input id="curUserAssignable0" type="radio" formControlName="curUserAssignable" [value]="0" />
                <span> Não</span>
              </label>
            </div>
          </div>

          <hr />
          <div class="form-group alert alert-danger text-center" *ngIf="userForm.dirty && userForm.invalid">
            Preencher todos os campos obrigatórios.
          </div>
          <div class="form-group">
            <button type="button" class="edp-btn btn-gray pull-left" (click)="cancel()">Cancelar</button>
            <button
              type="submit"
              class="edp-btn btn-yellow pull-right"
              [disabled]="userForm.invalid || !hasSelectedPermission()"
            >
              Confirmar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
